import { Link } from "react-router-dom";
import inputrylogo from "../assets/Inputrylogo.svg";

/** The orange waveform mark from the Inputry screens. */
export function Mark() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="46" height="25" viewBox="0 0 46 25" fill="none">
      <path d="M3.09525 15.1539C4.56093 15.1539 5.7491 13.9657 5.7491 12.5C5.7491 11.0344 4.56093 9.84619 3.09525 9.84619C1.62957 9.84619 0.441406 11.0344 0.441406 12.5C0.441406 13.9657 1.62957 15.1539 3.09525 15.1539Z" fill="url(#paint0_linear_199_5778)"/>
      <path d="M42.9038 15.1539C44.3695 15.1539 45.5577 13.9657 45.5577 12.5C45.5577 11.0344 44.3695 9.84619 42.9038 9.84619C41.4382 9.84619 40.25 11.0344 40.25 12.5C40.25 13.9657 41.4382 15.1539 42.9038 15.1539Z" fill="url(#paint1_linear_199_5778)"/>
      <path d="M7.07812 12.5H11.5012L13.7127 7.19227L16.3666 19.5769L19.4627 3.65381L22.5589 23.1153L25.2127 8.9615L27.4243 12.5H39.8089" stroke="url(#paint2_linear_199_5778)" strokeWidth="2.65385" strokeLinecap="round" strokeLinejoin="round"/>
      <defs>
        <linearGradient id="paint0_linear_199_5778" x1="-0.000901435" y1="0.115424" x2="45.9991" y2="0.115424" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFC83D"/>
          <stop offset="1" stopColor="#FF6B2C"/>
        </linearGradient>
        <linearGradient id="paint1_linear_199_5778" x1="2.14701e-06" y1="0.115424" x2="46" y2="0.115424" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFC83D"/>
          <stop offset="1" stopColor="#FF6B2C"/>
        </linearGradient>
        <linearGradient id="paint2_linear_199_5778" x1="0.0012012" y1="0.115347" x2="46.0012" y2="0.115347" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFC83D"/>
          <stop offset="1" stopColor="#FF6B2C"/>
        </linearGradient>
      </defs>
    </svg>
  );
}

export function Logo({ to = "/", className = "" }: { to?: string; className?: string }) {
  return (
    <Link to={to} className={`logo ${className}`} aria-label="Inputry">
      <img src={inputrylogo} alt="Inputry" />
      {/* <Mark />
      <span>Inputry</span> */}
    </Link>
  );
}
